import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activitySearchSetPageNumber } from '../../store/actions';
import Button from "../../UI/Button/Button";

const ActivityLogPaginationBtns = (props) => {

    const dispatch = useDispatch()

    const pageNumber = useSelector(state => state.agentActivity.activityLogPageNumber); 

    const onPrevClick = () => {
        dispatch(activitySearchSetPageNumber(pageNumber-1))
        props.nextClick(pageNumber-1)
    }

    const isPrevDisabled = () => {
        return pageNumber === 1
    }

    const onNextClick = () => {
        let newPageNumber = pageNumber + 1
        dispatch(activitySearchSetPageNumber(newPageNumber))
        props.nextClick(newPageNumber)
    } 

    return (
        <div style={{textAlign:'center'}}>
            <Button id="prevBtn" btnType="Search" disabled={isPrevDisabled()} clicked={onPrevClick}>{"<Prev"}</Button>
            <Button id="nextBtn" btnType="Search" disabled={!props.nextDisabled} clicked={onNextClick}>{"Next>"}</Button>
        </div>
    )
}

export default ActivityLogPaginationBtns;